export const DESKTOP_AD_ID1 = 'div-gpt-ad-1699446439291-0';
export const DESKTOP_AD_ID2 = 'div-gpt-ad-1699446562932-0';
export const DESKTOP_AD_ID3 = 'div-gpt-ad-1699447055826-0';

export const MOBILE_AD_ID1 = 'div-gpt-ad-1699447356026-0';
export const MOBILE_AD_ID2 = 'div-gpt-ad-1699447718762-0';
export const MOBILE_AD_ID3 = 'div-gpt-ad-1699448188606-0';
